import { Box } from '@mui/material'
import { FoxTypography } from '../../components/common/FoxTypography'
import { ZeroNotificationsIcon } from '../../components/icons/ZeroNotifications'
import { Colors } from '@foxtail-dev/user-clients'

export const NotificationsZeroState = (): JSX.Element => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box sx={{ marginTop: '168px', marginBottom: '24px' }}>
                <ZeroNotificationsIcon color={Colors.light.divider} />
            </Box>
            <FoxTypography light variant='h6' sx={{ marginBottom: '16px' }}>
                No notifications
            </FoxTypography>
            <FoxTypography variant='body1' sx={{ textAlign: 'center', width: '70%', color: 'rgba(0, 0, 0, 0.6)' }}>
                Your notifications will show up here
            </FoxTypography>
        </Box>
    )
}
